import { render, staticRenderFns } from "./GestionePackaging.vue?vue&type=template&id=710bc128&scoped=true&"
import script from "./GestionePackaging.vue?vue&type=script&lang=js&"
export * from "./GestionePackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bc128",
  null
  
)

export default component.exports